module.exports = __webpack_public_path__ + "img/bg-wallet-failed-modal.7e0cd551.webp";